import React from "react";
import {
  FaRobot,
  FaQuestion,
  FaClipboardList,
  FaMagic,
} from "react-icons/fa";
import {
  HiOutlineLightBulb,
  HiOutlineDocumentText,
  HiOutlineChartBar,
} from "react-icons/hi";
import { QuickAction, ModeConfig, ChatTheme } from "./types";

// ============================================================================
// Quick Actions
// ============================================================================

export const QUICK_ACTIONS: QuickAction[] = [
  {
    id: "setup",
    label: "Setup from use case",
    icon: React.createElement(FaMagic, { className: "h-3.5 w-3.5" }),
    prompt:
      "I have a use case I'd like to monitor. Help me set up everything: trackers on the right sources, a dashboard with relevant widgets, and alerts for important changes. Ask me about my use case first.",
  },
  {
    id: "insights",
    label: "Insights",
    icon: React.createElement(HiOutlineLightBulb, { className: "h-3.5 w-3.5" }),
    prompt: "Quels sont les insights clés de mes données ?",
  },
  {
    id: "summary",
    label: "Résumé",
    icon: React.createElement(HiOutlineDocumentText, { className: "h-3.5 w-3.5" }),
    prompt: "Fais-moi un résumé des dernières données collectées.",
  },
  {
    id: "chart",
    label: "Graphique",
    icon: React.createElement(HiOutlineChartBar, { className: "h-3.5 w-3.5" }),
    prompt: "Crée un graphique montrant l'évolution temporelle.",
  },
];

// ============================================================================
// Assistant Modes
// ============================================================================

export const ASSISTANT_MODES: ModeConfig[] = [
  {
    id: "agent",
    label: "Agent",
    icon: React.createElement(FaRobot, { className: "h-3 w-3" }),
    description: "Actions complètes avec modifications",
    color: "text-indigo-400",
    bgColor: "bg-indigo-500/20",
    textColor: "text-indigo-300",
  },
  {
    id: "ask",
    label: "Ask",
    icon: React.createElement(FaQuestion, { className: "h-3 w-3" }),
    description: "Questions et réponses (lecture seule)",
    color: "text-emerald-400",
    bgColor: "bg-emerald-500/20",
    textColor: "text-emerald-300",
  },
  {
    id: "plan",
    label: "Plan",
    icon: React.createElement(FaClipboardList, { className: "h-3 w-3" }),
    description: "Planification et structuration (lecture seule)",
    color: "text-amber-400",
    bgColor: "bg-amber-500/20",
    textColor: "text-amber-300",
  },
];

// ============================================================================
// Dark Theme (using sidebar CSS variables)
// ============================================================================

export const DARK_THEME: ChatTheme = {
  bg: "bg-[var(--arc-sidebar-background)]",
  border: "border-[var(--arc-sidebar-border-accent)]",
  textPrimary: "text-[var(--arc-sidebar-text-primary)]",
  textSecondary: "text-[var(--arc-sidebar-text-secondary)]",
  textMuted: "text-[var(--arc-content-tertiary)]",
  inputBg: "bg-[var(--arc-sidebar-gradient-end)]",
  inputBorder: "border-[var(--arc-sidebar-border-accent)]",
  buttonBg: "bg-[var(--arc-sidebar-gradient-middle)]",
  buttonHover: "hover:bg-[var(--arc-sidebar-gradient-end)]",
  userMsgBg: "bg-accent",
  userMsgText: "text-white",
  assistantMsgBg: "bg-[var(--arc-sidebar-gradient-middle)]",
  assistantMsgText: "text-[var(--arc-sidebar-text-primary)]",
  shadow: "shadow-[0_8px_32px_rgba(0,0,0,0.4)]",
  isDark: true,
};
